// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/demand_group_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { DemandGroupService } from "./demand_group_service_pb";

/**
 * CheckDemandGroupCsv parses and validates the CSV, returning a
 * check_token + count summary. organization_id is resolved by the BFF
 * handler from eauth.
 *
 * @generated from rpc bffuser.v1.DemandGroupService.CheckDemandGroupCsv
 */
export const checkDemandGroupCsv = DemandGroupService.method.checkDemandGroupCsv;

/**
 * ApplyDemandGroupCsv exchanges a valid check_token for the actual
 * registration. organization_id is resolved by the BFF handler from
 * eauth.
 *
 * @generated from rpc bffuser.v1.DemandGroupService.ApplyDemandGroupCsv
 */
export const applyDemandGroupCsv = DemandGroupService.method.applyDemandGroupCsv;

/**
 * ExportDemandGroups は組織内の論理削除されていない需要グループ所属 (供給地点)
 * 全行を CSV エクスポート用に返す (uploads/common.md §6, AC-DUC-028/029)。
 *
 * @generated from rpc bffuser.v1.DemandGroupService.ExportDemandGroups
 */
export const exportDemandGroups = DemandGroupService.method.exportDemandGroups;

/**
 * GetDemandGroupDirectory は需要グループ画面の目録。組織の全グループを返す
 * (エリアは各 entry が持ち、絞り込みは呼び出し側)。
 * feature_enabled=false and nothing else when the flag is off.
 *
 * @generated from rpc bffuser.v1.DemandGroupService.GetDemandGroupDirectory
 */
export const getDemandGroupDirectory = DemandGroupService.method.getDemandGroupDirectory;

/**
 * ListDemandGroupMembers は 1 グループの論理削除されていない所属供給地点
 * (supply_point_specific_number 昇順) を返す。
 * feature_enabled=false and nothing else when the flag is off.
 * NOT_FOUND when the demand group does not exist in the organization.
 *
 * @generated from rpc bffuser.v1.DemandGroupService.ListDemandGroupMembers
 */
export const listDemandGroupMembers = DemandGroupService.method.listDemandGroupMembers;
